const rootClass = 'weet-components-tag';
export { rootClass };
